import styled from "styled-components";

export const Container = styled.div`
    position: absolute;
    top: 1rem;
    right: 0.8rem;
    font-size: 1.4rem;
    color: var(--colorFontsCardsDashboard);

    display: flex;
    flex-direction: row-reverse;

    cursor: pointer;
    z-index: 100;
`;

export const ButtonExcelContainer = styled.div`
    display: flex;
    justify-content: center;
    flex-direction: column;
    background: #FFF;
    padding: 0.5rem;
    box-shadow: 0 2px 4px rgb(0 0 0 / 10%), 0 8px 16px rgb(0 0 0 / 10%);
    border-radius: 5px;

    
    button{
        border: 1px solid #237344;
        border-radius: 0.2rem;
        background: none;
        color: #237344;
        padding: 0.5rem 1.5rem;

        display: flex;
        align-items: center;
        justify-content: center;

        font-size: 0.9rem;

        svg{
            font-size: 1.5rem;
        }
    }
`;